import React from "react";

const StatCard = ({ aggregateData }) => {
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return "0";
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const stats = [
    {
      title: "Total Tickets",
      value: aggregateData?.ticketCount || 0,
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
        />
      ),
      bgColor: "bg-blue-100",
      iconColor: "text-blue-600",
      currency: false,
    },
    {
      title: "Total Paid",
      value: aggregateData?.totalPaidAmount || 0,
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
        />
      ),
      bgColor: "bg-green-100",
      iconColor: "text-green-600",
      currency: true,
    },
    {
      title: "To Be Refunded",
      value: aggregateData?.totaltoBeRefunded || 0,
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
        />
      ),
      bgColor: "bg-orange-100",
      iconColor: "text-orange-600",
      currency: true,
    },
    {
      title: "Refunded Amount",
      value: aggregateData?.totalRefundedAmount || 0,
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      ),
      bgColor: "bg-emerald-100",
      iconColor: "text-emerald-600",
      currency: true,
    },
  ];

  return (
    <>
      {stats.map((stat, index) => (
        <div
          key={index}
          className="overflow-hidden bg-white rounded-xl border border-gray-200 shadow-sm transition-shadow hover:shadow-md"
        >
          <div className="p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div
                  className={`flex justify-center items-center w-8 h-8 ${stat.bgColor} rounded-lg`}
                >
                  <svg
                    className={`w-5 h-5 ${stat.iconColor}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    {stat.icon}
                  </svg>
                </div>
              </div>
              <div className="flex-1 ml-4">
                <p className="text-sm font-medium text-gray-600">
                  {stat.title}
                </p>
                <p className="text-2xl font-bold text-gray-900">
                  {stat.currency && "ETB "}
                  {stat.currency ? formatCurrency(stat.value) : stat.value}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default StatCard;
